var exports = {
  "I": "xfd349460--dddc18--distance",
  "K": "xfd349460--dddc18--icon",
};

module.exports = exports;
